module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "unfinished",
    class: {
      finished: _vm.finished
    }
  }, [_c('span', {
    staticClass: "icon",
    class: {
      complete: _vm.finished
    },
    domProps: {
      "textContent": _vm._s(_vm.finished ? '' : _vm.index)
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "title",
    domProps: {
      "textContent": _vm._s(_vm.title)
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-23277806"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/WorkItem.vue
// module id = 764
// module chunks = 1